import React from 'react'
import ReactDOM from 'react-dom'
import ModalAlertComponent from '../components/modal-alert'

export default function ModalAlert ({onClose, ...props}) {
  const el = document.createElement('div')

  const handleClose = () => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(el)
      el.remove()
    }, 300)
  }

  document.body.appendChild(el)
  ReactDOM.render(<ModalAlertComponent onClose={handleClose} {...props} />, el)
}
